import React, { FC } from 'react';

import FundLetterIndex from 'buyside/components/presentation/FundLetterIndex/fundLetterIndex';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';

const FundLetterIndexPageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="the fund letter index">
      <FundLetterIndex />
    </ErrorBoundary>
  );
};

export default FundLetterIndexPageRoot;
